// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"InvitationList_tableHeader_1OcLn"};